import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/website/Home';
import Service from '../views/website/Service';
import News from '../views/website/News';
import About from '../views/website/About';
import Job from '../views/website/Job';
import Contact from '../views/website/Contact';

import { locatTo, isWirelessDevice } from '../utils/utils';

Vue.use(Router);

const websiteRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/service',
      name: 'service',
      component: Service,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/news',
      name: 'news',
      component: News,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/job',
      name: 'job',
      component: Job,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
  ],
});

websiteRouter.afterEach(to => {
  const isMobile = isWirelessDevice();
  let scrollTop = 0;

  if (to.query.post && (to.name === 'service' || to.name === 'news')) {
    scrollTop = 500;
  }

  if (isMobile) {
    scrollTop = 0;
  }

  locatTo(scrollTop);
});

export default websiteRouter;
